import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';
import { StatusService } from '../../services/status.service';


@Component({
  selector: 'app-system-status',
  templateUrl: './system-status.component.html',
  styleUrls: ['./system-status.component.css']
})
export class SystemStatusComponent implements OnInit {
  realtime: boolean =  true;
  statuses: Route[] = []
  routes: Route[] = [];
  mode: string = '';
  public screen: any;

  constructor(private statusService: StatusService, private routeService: RouteService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.mode = this.route.snapshot.paramMap.get('mode');
    if(!['rail','subway','nhsl','other','trolley','cct'].includes(this.mode)){
      this.mode = 'bus';
    }

    //this.routes = this.routeService.routes;
    this.getRoutes();


    this.screen = window.innerWidth;
  }

  getRoutes(): void {
    this.statusService.get()
        .subscribe(statuses => {
          this.statuses = statuses;
          this.realtime = this.statusService.realtime;
        });
  }

  onDetail(route: Route): void{
    this.routeService.detail(route);
    this.router.navigate(['/routes/status'])
  }
}
